/**
 * `@storyboard/db-utils`.
 *
 * `db-utils` is consumed from both the Node backend and the browser (via
 * `@storyboard/web`), so it cannot import the Node-only `@storyboard/logger`
 * — that package pulls in `async_hooks`, `@sentry/node`, `aws-lambda`, and
 * SQS types at module load time and breaks the Vite build. Any caller that
 * has a logger can pass it in; the shape matches the three argument kinds
 * the backend `Logger` already accepts (a message string, an attributes
 * bag, and/or an `Error`), which also lets callers pass the shared
 * `Logger` singleton directly.
 */
export interface Logger {
  debug(message: string, attributes?: Record<string, unknown>, error?: Error): void;
  error(message: string, attributes?: Record<string, unknown>, error?: Error): void;
}

/** Logger that never emits. Used as the default when no logger is supplied. */
export const NOOP_LOGGER: Logger = {
  debug: () => {},
  error: () => {},
};
